export enum SelectWidth {
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large',
}

export type Option = {
	label: string
	value: string
	isSelected?: boolean
	[key: string]: unknown
}
